export default "__VITE_ASSET__CTolYqtr__";